(() => {
  let controller;
  let previousCartIcon;
  function initialize(){
  controller?.abort();
  controller=new AbortController();
  const signal=controller.signal;
  const one = (s, root=document) => root.querySelector(s);
  const all = (s, root=document) => [...root.querySelectorAll(s)];
  const productNode=one('#pf-product-data');
  const product=productNode?JSON.parse(productNode.textContent):null;
  const words=JSON.parse(one('#pf-translations')?.textContent||'{}');
  const bars=all('.kaching-bundles__bar');
  const sizes=all('pf-variant-selects input[name="Size"]').map(n=>n.value);
  let pack=Number(one('.kaching-bundles__bar--selected')?.dataset.pack||2);
  const selection=name=>one(`pf-variant-selects input[name="${name}"]:checked`)?.value;
  const label=one('.main-atc__label__text');
  const button=one('.main-product-atc');
  if(button?.dataset.addLabel)words.add=button.dataset.addLabel;
  const notice=one('#pf-cart-message');
  const variantFor=()=>product?.variants.find(v=>v.option1===selection('Size')?.split(' ')[0]&&v.option2===selection('Side')&&v.option3===`${pack} sleeve${pack===1?'':'s'}`);
  function updateVariant(){
    const variant=variantFor();
    if(button){button.disabled=!variant?.available;label.textContent=variant?.available?words.add:words.unavailable;}
    const input=one('#pf-original-product-form input[name="id"]');
    if(input)input.value=variant?.id||'';
  }
  function renderOptions(bar){
    const count=Number(bar.dataset.pack), container=one('.pf-pack-options',bar);
    container.replaceChildren();
    if(count===1)return;
    for(let i=0;i<count;i++){
      const row=document.createElement('div');row.className='pf-pack-row';
      const number=document.createElement('span');number.textContent=`# ${i+1}`;row.append(number);
      for(const [name,values] of [['Size',sizes],['Side',['Left','Right']]]){
        const select=document.createElement('select');select.dataset.option=name;select.dataset.sleeve=String(i+1);select.setAttribute('aria-label',`${words[name.toLowerCase()]} ${i+1}`);
        values.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;option.selected=value===selection(name);select.append(option);});
        select.addEventListener('click',e=>e.stopPropagation(),{signal});
        select.addEventListener('change',()=>{
          if(i===0){const radio=all(`pf-variant-selects input[name="${name}"]`).find(r=>r.value===select.value);if(radio)radio.checked=true;updateVariant();}
        },{signal});row.append(select);
      }
      container.append(row);
    }
  }
  function choose(bar){
    pack=Number(bar.dataset.pack);
    bars.forEach(b=>{const selected=b===bar;b.classList.toggle('kaching-bundles__bar--selected',selected);b.setAttribute('aria-checked',String(selected));const r=one('input[type=radio]',b);if(r)r.checked=selected;});
    renderOptions(bar);
    all('select[data-sleeve="1"]',bar).forEach(s=>s.value=selection(s.dataset.option));updateVariant();
  }
  bars.forEach(bar=>{
    bar.addEventListener('click',e=>{if(e.target.closest('select'))return;e.preventDefault();choose(bar);},{signal});
    bar.addEventListener('keydown',e=>{if(e.target!==bar)return;if(e.key==='Enter'||e.key===' '){e.preventDefault();choose(bar);}},{signal});
  });
  all('pf-variant-selects input').forEach(r=>r.addEventListener('change',()=>{
    const selected=bars.find(b=>Number(b.dataset.pack)===pack);
    all(`select[data-option="${r.name}"]`,selected).forEach(s=>s.value=r.value);updateVariant();
  },{signal}));
  if(bars.length)choose(bars.find(b=>Number(b.dataset.pack)===pack)||bars[0]);
  one('#pf-original-product-form')?.addEventListener('submit',async e=>{
    e.preventDefault();const v=variantFor();if(!v?.available)return;
    button.disabled=true;label.textContent=words.adding;notice.textContent='';
    const selected=bars.find(b=>Number(b.dataset.pack)===pack);
    const properties={};
    if(pack>1)all('.pf-pack-row',selected).forEach((row,i)=>{properties[`Sleeve ${i+1}`]=`${one('[data-option="Size"]',row).value} / ${one('[data-option="Side"]',row).value}`;});
    try{
      const drawer=one('cart-drawer');
      const sections=drawer?.getSectionsToRender?.().map(section=>section.id)||[];
      drawer?.setActiveElement?.(button);
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties}],sections,sections_url:location.pathname})});
      const result=await response.json();if(!response.ok)throw Error(result.description||words.error);
      if(drawer&&result.sections&&Object.values(result.sections).every(Boolean)){
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
        updateVariant();
      }else{location.href=`${window.Shopify?.routes?.root||'/'}cart`;}
    }catch(error){notice.textContent=error.message||words.error;updateVariant();}
  },{signal});
  const gallery=one('.product__media-list');
  const slides=all('.product__media-item',gallery||document);
  function show(index){slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));all('.thumbnail',document).forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));}
  all('.thumbnail-list__item').forEach((li,i)=>one('button',li)?.addEventListener('click',()=>show(i),{signal}));
  let startX=0;
  gallery?.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;},{...({passive:true}),signal});
  gallery?.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45){const i=slides.findIndex(s=>s.classList.contains('is-active'));show((i+(dx<0?1:-1)+slides.length)%slides.length);}},{...({passive:true}),signal});
  all('.thumbnail-slider .slider-button').forEach(b=>{b.disabled=false;b.addEventListener('click',()=>one('.thumbnail-list')?.scrollBy({left:b.name==='previous'?-250:250,behavior:'smooth'}),{signal});});
  all('.product__media-list img').forEach(img=>img.addEventListener('click',()=>{one('#pf-zoom-image').src=img.src;one('#pf-image-dialog').showModal();},{signal}));
  one('.sizing-chart__button')?.addEventListener('click',()=>one('#pf-size-dialog').showModal(),{signal});
  all('[data-close-dialog]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close(),{signal}));
  all('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d)d.close();},{signal}));
  one('.pf-mobile-menu')?.remove();
  const cartIcon=one('#cart-icon-bubble');
  if(previousCartIcon && previousCartIcon!==cartIcon)one('cart-drawer')?.setHeaderCartIconAccessibility?.();
  previousCartIcon=cartIcon;
  const mobileMenu=document.createElement('details');mobileMenu.className='pf-mobile-menu';
  mobileMenu.innerHTML='<summary aria-label="Menu"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor"><path d="M2 5h18M2 11h18M2 17h18"/></svg></summary><nav><a href="/">Home</a><a href="/collections/all">All Products</a><a href="/pages/contact">Contact</a><a href="/pages/track-order">Track Order</a></nav>';
  const mobileNav=one('nav',mobileMenu);
  const menuLinks=all('.header__inline-menu a');
  if(menuLinks.length)mobileNav.replaceChildren(...menuLinks.map(a=>{const link=document.createElement('a');link.href=a.getAttribute('href');link.textContent=a.textContent.trim();return link;}));
  one('header.header')?.prepend(mobileMenu);
  const sort=one('.jdgm-sort-dropdown');
  const reviews=all('.jm-review-item');
  const reviewContainer=one('.jdgm-review-list');
  const rating=r=>Number(one('[aria-label$="stars"]',r)?.getAttribute('aria-label')?.split(' ')[0]||0);
  function sortReviews(){
    const order=sort?.value||'created_at';
    reviews.forEach(r=>r.hidden=order==='with_pictures'&&!one('img',r));
    const sorted=[...reviews];
    if(order==='highest_rating')sorted.sort((a,b)=>rating(b)-rating(a));
    if(order==='lowest_rating')sorted.sort((a,b)=>rating(a)-rating(b));
    if(order==='pictures_first')sorted.sort((a,b)=>Number(!!one('img',b))-Number(!!one('img',a)));
    sorted.forEach(r=>reviewContainer?.append(r));
  }
  sort?.addEventListener('change',sortReviews,{signal});
  one('button[aria-label="Filters"]')?.addEventListener('click',()=>{if(sort){sort.value=sort.value==='with_pictures'?'created_at':'with_pictures';sortReviews();}},{signal});
  one('[data-testid="write-review-button"]')?.addEventListener('click',()=>location.href='/pages/contact',{signal});
  all('.jm-media-grid__item,.jm-review-item [role="button"]').forEach(b=>b.addEventListener('click',()=>{const img=one('img',b);if(img){one('#pf-zoom-image').src=img.src;one('#pf-image-dialog').showModal();}},{signal}));
  one('#hsaLearnMoreBtn')?.addEventListener('click',()=>{location.href='https://truemed.com/disclosures';},{signal});

  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
